import { Film, Showtime } from '@vista-digital/ocapi-types/v1'
import { OccI18N, useI18n } from '@vista-digital/occ-ui'
import { navigationService } from '.'
import { PagesEnum } from '../pages'
import { cmsDataService } from '.'

class UrlService {
    private i18n: OccI18N
    setI18n(i18n: OccI18N) {
        this.i18n = i18n
    }

    getFilmDetailsUrl(film: Film): string {
        // Sometimes a film may not have a translatable name
        const filmName = film.title.translations.length > 0 ? this.i18n.translatable(film.title) : film.title.text

        return navigationService.getPageUrl(PagesEnum.MovieDetails, {
            filmName: this.urlFriendly(filmName),
            filmId: film.id,
        })
    }

    getShowtimeUrl(showtime: Showtime): string {
        return cmsDataService.get().lumos.baseUrl + '#/order/seats/?showtimeId=' + showtime.id
    }

    //Takes a string and returns it in a url-compatible format
    urlFriendly(urlInput: string): string {
        return urlInput
            .replace(/\s+/g, '-')
            .replace(/-{2,}/g, '-')
            .replace(/[^a-zA-Z0-9-]/g, '')
            .toLowerCase()
    }

    isRouted(url: string) {
        return url.startsWith('/') || url.startsWith(document.location.origin)
    }

    lastUrlSegment(url: string) {
        return url
            .split('/')
            .filter(i => i)
            .pop()
    }

    getRoutedUrl(url: string) {
        if (url.startsWith(document.location.origin)) return url.substring(document.location.origin.length)
        return url
    }

    // Cinema
    // getCinemaUrl(cinemaName: string) {
    //     return navigationService.getPageUrl(PagesEnum.Cinema, {
    //         cinemaName: cinemaName,
    //     })
    // }
}

export const urlService = new UrlService()
